import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss']
})
export class InfoCardComponent implements OnInit {

  icon: boolean = true;
  text: string = "¿Estás seguro de que deseas cancelar? Se perderán todos los datos introducidos.";
  btnCancel: boolean = true;
  warning: boolean = false;
  success: boolean = false;
  textButton: string = 'Aceptar';
  textCancel: string = 'Cancelar';
  showCloseBtn: boolean = false;
  choices: Array<{label: string; value: string}> | null = null;
  selectedChoice: string = '';

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data) {
    if(data) {
      this.icon = data.icon;
      this.text = data.text;
      this.btnCancel = data.btnCancel;
      this.warning = data.warning;
      this.success = data.success || false;
      this.textButton = data.textButton || 'Aceptar';
      this.textCancel = data.textCancel || 'Cancelar';
      this.showCloseBtn = data.showCloseBtn || false;
      this.choices = data.choices || null;
      this.selectedChoice = data.choices?.[0]?.value ?? '';
    }
  }

  ngOnInit(): void {
  }

}
